<template>
  <div v-if="value.length > 0">
    <img
      v-if="!show"
      :src="require('@/assets/images/svg/ícone-não-valido.svg')"
      style="margin-right: 18px"
      alt=""
    />
    <img
      v-else
      style="margin-right: 18px"
      :src="require('@/assets/images/svg/ícone-valido.svg')"
      alt=""
    />
  </div>
</template>
<script>
export default {
  name: "IconValidation",
  props: {
    value: String,
    show: Boolean,
  },
};
</script>
